
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface FeatureCoverageCardProps {
  featureCoverage: {
    advancedMetricsPercentage?: string | number;
    extractedFeaturesPercentage?: string | number;
    linguisticFeaturesPercentage?: string | number;
    sentimentAnalysisPercentage?: string | number;
    rhetoricPatternsPercentage?: string | number;
    formalityAnalysisPercentage?: string | number;
  } | undefined;
}

export const FeatureCoverageCard: React.FC<FeatureCoverageCardProps> = ({ featureCoverage }) => {
  if (!featureCoverage) return null;
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Feature Coverage</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <div className="flex items-center justify-between">
              <div className="text-sm">Advanced Metrics</div>
              <div className="text-sm font-medium">{featureCoverage?.advancedMetricsPercentage || 0}%</div>
            </div>
            <Progress 
              value={parseFloat(featureCoverage?.advancedMetricsPercentage?.toString() || "0")} 
              className="h-2 mt-2" 
            />
          </div>
          
          <div>
            <div className="flex items-center justify-between">
              <div className="text-sm">Extracted Features</div>
              <div className="text-sm font-medium">{featureCoverage?.extractedFeaturesPercentage || 0}%</div>
            </div>
            <Progress 
              value={parseFloat(featureCoverage?.extractedFeaturesPercentage?.toString() || "0")} 
              className="h-2 mt-2" 
            />
          </div>
          
          <div>
            <div className="flex items-center justify-between">
              <div className="text-sm">Linguistic Features</div>
              <div className="text-sm font-medium">{featureCoverage?.linguisticFeaturesPercentage || 0}%</div>
            </div>
            <Progress 
              value={parseFloat(featureCoverage?.linguisticFeaturesPercentage?.toString() || "0")} 
              className="h-2 mt-2" 
            />
          </div>
          
          <div>
            <div className="flex items-center justify-between">
              <div className="text-sm">Sentiment Analysis</div>
              <div className="text-sm font-medium">{featureCoverage?.sentimentAnalysisPercentage || 0}%</div>
            </div>
            <Progress 
              value={parseFloat(featureCoverage?.sentimentAnalysisPercentage?.toString() || "0")} 
              className="h-2 mt-2" 
            />
          </div>
          
          {featureCoverage?.rhetoricPatternsPercentage && (
            <div>
              <div className="flex items-center justify-between">
                <div className="text-sm">Rhetoric Patterns</div>
                <div className="text-sm font-medium">{featureCoverage.rhetoricPatternsPercentage}%</div>
              </div>
              <Progress 
                value={parseFloat(featureCoverage.rhetoricPatternsPercentage.toString())} 
                className="h-2 mt-2" 
              />
            </div>
          )}
          
          {featureCoverage?.formalityAnalysisPercentage && (
            <div>
              <div className="flex items-center justify-between">
                <div className="text-sm">Formality Analysis</div>
                <div className="text-sm font-medium">{featureCoverage.formalityAnalysisPercentage}%</div>
              </div>
              <Progress 
                value={parseFloat(featureCoverage.formalityAnalysisPercentage.toString())} 
                className="h-2 mt-2" 
              />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
